import React, { Component } from "react";
import { IonSelect, IonSelectOption } from "@ionic/react";

import { Collapse } from "react-collapse";

// CSS
import "../Shared.css";
import "../../App.css";
import "./AgeSelector.css";

// Controllers
import { IPatientAge } from "../Interfaces";
import DataController from "../controllers/DataController";

type Props = {
  patientAge: IPatientAge;
  patientAgeChanged: (patientAge: IPatientAge) => void;
  className?: string;
};
type State = {};

class AgeSelector extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
  }

  comparePatientAge(o1: IPatientAge, o2: IPatientAge) {
    return o1 && o2 ? o1.name === o2.name : o1 === o2;
  }

  updatePatientAge(event: any) {
    if (this.props.patientAgeChanged != null) {
      this.props.patientAgeChanged(event.target.value);
    }
  }

  render() {
    let patientAgeSelectOptions = [];

    let patientAges = DataController.getAgesObjects();

    for (let patientAgeIndex = 0; patientAgeIndex < patientAges.length; patientAgeIndex++) {
      let patientAge = patientAges[patientAgeIndex];

      if (patientAge.name === "12 to Adult") {
        patientAgeSelectOptions.push(
          <IonSelectOption key="Adult" disabled={true}>
            {"Adult"}
          </IonSelectOption>
        );
      }

      if (patientAge.name === "2 years") {
        patientAgeSelectOptions.push(
          <IonSelectOption key="Child" disabled={true}>
            {"Child"}
          </IonSelectOption>
        );
      }

      if (patientAge.name === "At Birth") {
        patientAgeSelectOptions.push(
          <IonSelectOption key="Infant" disabled={true}>
            {"Infant"}
          </IonSelectOption>
        );
      }

      patientAgeSelectOptions.push(
        <IonSelectOption key={patientAge.name} value={patientAge}>
          {patientAge.name}
        </IonSelectOption>
      );
    }

    return (
      <div className={this.props.className}>
        <IonSelect
          className={`ageSelectorContainer ${this.props.patientAge.age !== "All" ? "ageSelectorSelectedAge" : ""}`}
          interface="popover"
          interfaceOptions={{ cssClass: "age-selector-class" }}
          mode="ios"
          onIonChange={(event) => this.updatePatientAge(event)}
          id="ageSelect"
          placeholder="All"
          compareWith={this.comparePatientAge}
          value={this.props.patientAge}
        >
          {patientAgeSelectOptions}
        </IonSelect>
      </div>
    );
  }
}

export default AgeSelector;
